import * as React from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';
import { connect } from 'react-redux';
import './custom.css'
import Update from './components/Update';
import Responses from './components/Responses';
import Home from './components/Home';
import axios from 'axios';
import { useAppDispatch, useAppSelector } from './store';
import { LoadingSpinner } from '@qualtrics/ui-react';
import { addClientID } from './store/clientIDSlice';
import { addBearerToken, removeBearerToken } from './store/bearerTokenSlice';

const App = () => {

    const clientID = useAppSelector(state => state.clientID.value);
    const bearerToken = useAppSelector(state => state.bearerToken.value);

    const fiftyNineMins = 3540000;

    const dispatch = useAppDispatch();


    // get client id from backend
    const getClientID = async () => {
        const client_id =  (await axios.get<string>(`/api/get_clientid`)).data;

        // store client id in Redux store
        dispatch(addClientID(client_id));
    };

    // get client id from backend if not already done
    React.useEffect(() => {
        try {
            if (clientID === "") {
                getClientID();
            }
        } catch (error) {
            console.log(error);
        }

    }, [clientID]);

    // set timer to remove bearer token from store after 59 minutes
    const removeSetTimeout = () => {
        setTimeout(() => {
            dispatch(removeBearerToken());
            window.location.href = "/";
        }, fiftyNineMins);
    } 

    //get code from url after login and use it to get auth token
    const getToken = async () => {
        try {

            // get code from login from url
            const code = new URLSearchParams(window.location.search).get('code');
            
            if (code) {
                var encodedUri = encodeURIComponent(`https://${window.location.hostname}/`);

                // get auth token
                var tokenResponse = await axios.get(`/api/get_token`, {
                    params: {
                        code: code,
                        encodedUri: encodedUri
                    }
                });

                // store authtoken
                dispatch(addBearerToken(tokenResponse.data.access_token));

                removeSetTimeout();
            }

        } catch (error) {
            console.log(error);
        }
    }

    React.useEffect(() => {
        if (bearerToken === "") {
            getToken();
        }
    }, [bearerToken]);

    return (
        <div>
            {clientID === ""
                ? <div className="loadingSpinner"><LoadingSpinner show size="large" /></div>
                :  <Layout>
                    <Route exact path='/' component={Home} />
                    <Route path='/responses' component={Responses} />
                    <Route path='/update' component={Update} />
                </Layout>
            }
        </div>
        
    );

}

export default connect()(App);
